import { createSelector } from 'reselect'

import { User, UsersById, UserStatus } from '@driftt/api-types'

const rootOrgSelector = (state) => state.org
const rootUserSelector = (state) => state.user

export const orgUsers = createSelector(
  rootOrgSelector,
  (org): User[] => org.users
)

export const allOrgUsers = createSelector(
  rootOrgSelector,
  (org): User[] => org.allUsers
)

export const getUserDisplayName = (user: User): string | undefined =>
  user ? user.name || user.email : undefined

export const orgId = createSelector(
  rootUserSelector,
  (user): number => user.orgId
)

export const org = createSelector(rootOrgSelector, (org): any => org)

export const userId = createSelector(
  rootUserSelector,
  (user): number => user.id
)

export const userEmail = createSelector(
  rootUserSelector,
  (user): string => user.email || ''
)

export const getUserProperty = (propertyName: string) =>
  createSelector(
    rootUserSelector,
    (user): number => user.settings[propertyName]
  )

export const getOrgProperty = (propertyName: string) =>
  createSelector(rootOrgSelector, (org): number => org.properties[propertyName])

export const orgCreatedAt = createSelector(
  rootOrgSelector,
  (org): number => org.createdAt
)

export const unfilteredOrgUsersById = createSelector(
  allOrgUsers,
  (users: User[]): UsersById => {
    const result = {}
    users.forEach((user) => {
      result[user.id] = {
        ...user,
        name:
          user.status === UserStatus.ARCHIVED
            ? `${getUserDisplayName(user)} [DELETED]`
            : user.name,
      }
    })
    return result
  }
)

export const activeOrgUsersWithEmailAdresses = createSelector(
  allOrgUsers,
  (users: User[]): User[] => {
    return users.filter((user) => !!user.email && user.status === 'ENABLED')
  }
)

export const activeOrgUsersWithEmailAdressesOptions = createSelector(
  activeOrgUsersWithEmailAdresses,
  (users) => {
    return users.map((user) => ({
      label: user.name || user.email || 'Unknown User',
      value: user.id.toString(),
    }))
  }
)
